import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, switchMap, take } from 'rxjs';
import { environment } from '../../environments/environment';
import { IVectorKpiPayload } from '../interfaces/sjmap2/vector/IVectorKpi';
import { selectValidateTokenIsValid } from '../store/selectors/shared-explorer-link.selector';

@Injectable({
  providedIn: 'root',
})
export class VectorKpiService {
  private http: HttpClient = inject(HttpClient);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private store: Store = inject(Store);

  private API_URL: string = environment.services.urlEDI;

  loadHiddenVectorKpiPayload(
    vectorKpiUuid: string,
    projectUUID: string | null = null,
  ): Observable<IVectorKpiPayload> {
    return combineLatest([
      this.store.select(selectValidateTokenIsValid),
      this.route.queryParamMap,
    ]).pipe(
      take(1),
      switchMap(([isValidToken, queryParams]) => {
        const token = queryParams.get('token') ?? '';
        const resolvedProjectUUID =
          projectUUID ?? this.getRouteParam('projectUUID');

        const url =
          isValidToken && token && resolvedProjectUUID
            ? `${this.API_URL}/explorer_share_token/${resolvedProjectUUID}/vector-kpi/${vectorKpiUuid}?token=${encodeURIComponent(token)}`
            : `${this.API_URL}/vector_kpi/${vectorKpiUuid}`;

        return this.http.get<IVectorKpiPayload>(url);
      }),
    );
  }

  private getRouteParam(paramName: string): string | null {
    let currentRoute: ActivatedRoute | null = this.route.root;

    while (currentRoute) {
      const value = currentRoute.snapshot.paramMap.get(paramName);
      if (value) {
        return value;
      }

      currentRoute = currentRoute.firstChild;
    }

    return null;
  }
}
